var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col py-1 d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"col px-1 py-1 text-left"},[_c('div',{staticClass:"CompanyTitleContainer",domProps:{"innerHTML":_vm._s(_vm.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }